<xux-widget-boilerplate
  [class]="(field.disabledObs | async) ? 'disabled' : ''"
  [field]="field"
  [attr.data-disabled-tooltip]="(disabledTooltip$ | async) || disabledTooltip$"
>
  <!-- see dropdown documentation at https://valor-software.com/ngx-bootstrap/#/dropdowns -->
  <div
    (click)="selectClickHandler()"
    [isDisabled]="disabled"
    class="btn-group dropdown xux-dropdown"
    dropdown
    #dropdown="bs-dropdown"
    [attr.aria-expanded]="isMenuAlreadyOpen"
  >
    <button
      #defaultFocusElement
      class="btn dropdown-toggle"
      type="button"
      #selectBtn
      [tabindex]="(field.disabledObs | async) ? -1 : 0"
      (click)="displayMenu($event)"
    >
      {{ selectedItemText$ | async }}<span class="glyphicon glyphicon-menu-down"></span>
    </button>
  </div>
</xux-widget-boilerplate>
